export default __webpack_public_path__ + "static/media/australia.d50ff6ed.svg";